import {
  Question,
  isSingleChoiceQuestion,
  isSliderQuestion,
} from "../../types/Question";
import { SingleChoiceQuestion } from "./SingleChoiceQuestion";
import { AnswerOptionId } from "../../types/AnswerOption";
import { SliderQuestion } from "./SliderQuestion";

type UniversalQuestionProps = {
  question: Question;
  subtitle?: string;
  onSelect: (answerId: AnswerOptionId) => void;
  gift?: boolean;
};

export const UniversalQuestion = ({
  question,
  subtitle,
  onSelect,
  gift,
}: UniversalQuestionProps) => {
  if (isSingleChoiceQuestion(question)) {
    return (
      <SingleChoiceQuestion
        subtitle={subtitle}
        question={question.question}
        options={question.options}
        onSelect={onSelect}
        gift={gift}
      />
    );
  }

  if (isSliderQuestion(question)) {
    return (
      <SliderQuestion
        subtitle={subtitle}
        question={question.question}
        minLabel={question.minLabel}
        maxLabel={question.maxLabel}
        options={question.options.map((option) => option.label)}
        onSelect={(selectedLabel) => {
          const selectedOption = question.options.find(
            (option) => option.label === selectedLabel
          );
          if (selectedOption) {
            onSelect(selectedOption.id);
          }
        }}
      />
    );
  }

  return null;
};
